import { Locale } from 'vant'
const kLanguage = 'language'

var localLanguage = localStorage.getItem(kLanguage) || 'auto'
var systemlanguage = navigator.language.substr(0, 2);
var storageLanguage;
var selectedLanguage;
var requestLanguage;

var getLanguage = (lang, isAuto) => {
  switch (lang) {
    case 'ar':
      selectedLanguage = require('./lang/ar-JO').default
      storageLanguage = isAuto ? 'auto' : 'ar';
      requestLanguage = 'ar';
      break
    case 'en':
      selectedLanguage = require('./lang/en-US').default
      storageLanguage = isAuto ? 'auto' : 'en'
      requestLanguage = 'en';
      break
    case 'zh':
      selectedLanguage = require('./lang/zh-CN').default
      storageLanguage = isAuto ? 'auto' : 'zh'
      requestLanguage = 'zh';
      break
    default:
      selectedLanguage = require('./lang/en-US').default
      storageLanguage = isAuto ? 'auto' : 'en'
      requestLanguage = 'en';
  }
}
if (localLanguage == 'auto') {
  getLanguage(systemlanguage, true);
} else {
  getLanguage(localLanguage, false);
}

Locale.use(localLanguage, selectedLanguage)
localStorage.setItem(kLanguage, storageLanguage)

export const Language = selectedLanguage

export default {
  install: function (Vue) {
    Vue.prototype.$t = selectedLanguage
  },
  language: storageLanguage,
  requestLanguage: requestLanguage
}
